import { html, LitElement, nothing } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { unsafeSVG } from 'lit/directives/unsafe-svg.js';
import Styles from './vm-icon-next.scss';

const iconModules = import.meta.glob('./assets/ic-*.svg', {
    query: '?raw',
    import: 'default',
});

export const iconNames = [
    'arrow-narrow-right',
    'arrow-narrow-up-right',
    'arrow-up',
    'award-03',
    'check-circle',
    'edit-05',
    'external-link',
    'image-03',
    'link-01',
    'plus',
    'play',
    'search',
    'sparkle',
    'stars-01',
    'stop',
    'x-close',
] as const;
export type IconName = (typeof iconNames)[number];

const cache = new Map<string, string>();

@customElement('vm-icon-next')
export class VmIconNext extends LitElement {
    static override styles = Styles;

    @property()
    name!: IconName;

    @property({ reflect: true })
    size: 'xs' | 'sm' | 'md' | 'lg' | 'xl' = 'md';

    @state()
    private svg = '';

    override willUpdate(changed: Map<string, unknown>) {
        if (changed.has('name')) {
            this.loadIcon();
        }
    }

    private async loadIcon() {
        const { name } = this;

        if (!name) {
            this.svg = '';
            return;
        }

        const cached = cache.get(name);
        if (cached) {
            this.svg = cached;
            return;
        }

        const loader = iconModules[`./assets/ic-${name}.svg`];
        if (!loader) {
            this.svg = '';
            return;
        }

        const svg = (await loader()) as string;
        cache.set(name, svg);

        // Guard against name changing while awaiting
        if (this.name === name) {
            this.svg = svg;
        }
    }

    override render() {
        return this.svg ? html`${unsafeSVG(this.svg)}` : nothing;
    }
}
